import { URL } from '../../../../api'
import { Link } from 'react-router-dom'

const DownloadPage = ({ data, lang }) => {
    return (
        <div className='container'>
            <div className='w-100 mt-2'><img src={`${URL}${data?.files[0]}`} alt='' className='w-100' /></div>
            <div className='mt-4'>
                <div className='w-100 text-center'><h2><strong>{data?.description[lang]}</strong></h2></div>
                <div className='mt-3' dangerouslySetInnerHTML={{ __html: data?.content[lang] }}></div>
                <div className='mt-4 bottom-imgs'>
                    {
                        (data?.modules ? [...data?.modules] : [])
                            .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                            .map((item, index) => {
                                return (
                                    <div key={index} className='mx-2'>
                                        <Link target='_blank' to={item?.description[lang]}>
                                            <img src={`${URL}${item?.files[0]}`} alt='' className='h50' style={{ width: "148px", object: "cover", height: 50 }} />
                                        </Link>
                                    </div>
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}

export default DownloadPage
